import * as React from 'react'

import { containerStyles } from '../../styles/ContainerStyles'

export const PageWrapper: React.FC = ({
    children,
}) => {
    const classes = containerStyles()

    return (
        <div>
            <div className={classes.pageWrapper}>
                {children}
            </div>
        </div>
    )
}
